import registeredFunctions from './registeredFunctions'

export function registerSearchOptionsBuilder(id, fn) {
    registeredFunctions[id] = fn
}

export function buildSearchOptions(lists) {
    Object.values(registeredFunctions).forEach((fn) => fn(lists))
}
